import { render, staticRenderFns } from "./Cuenta_x_Cobrar.vue?vue&type=template&id=c7109c46"
import script from "./Cuenta_x_Cobrar.vue?vue&type=script&lang=js"
export * from "./Cuenta_x_Cobrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports